import React, { useState, useRef, useContext } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField, Select, MenuItem } from '@mui/material';
import { UserMasterType, useUserMaster } from '../DataFetch/useUserMaster';
import { AuthorityMasterType, useAuthorityMaster } from '../DataFetch/useAuthorityMaster';
import { UserMasterEdit } from './UserMasterEdit';
import { useSuccessDialog } from '../Component/useSuccessDialog';
import { useErrorDialog } from '../Component/useErrorDialog';
import { useConfirmDialog } from '../Component/useConfirmDialog';
import { SessionContext } from '../ManagementRoot';
import { PostReleaseUser } from '../DataFetch/ManagementAPI';

export function UserMaster() {

    const {userMaster, mutate} = useUserMaster();

    const {authorityMaster} = useAuthorityMaster();

    const [editing, setEditing] = useState<boolean>(false);

    const [editData, setEditData] = useState<UserMasterType | undefined>(undefined);

    const ConfirmSession = useContext(SessionContext);

    const {openSuccessDialog, SuccessDialog} = useSuccessDialog();

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const {waitConfirm, ConfirmDialog} = useConfirmDialog();

    async function OpenEditor(data:UserMasterType | undefined) {

        if(!await ConfirmSession()) {
            return;
        }

        setEditData(data);
        setEditing(true);
    }

    function CompleteEdit() {
        setEditing(false);
        mutate();
    }

    async function ReleaseUser(userId:number) {

        if(!await ConfirmSession()) {
            return;
        }

        waitConfirm("選択状態を解除します。よろしいですか？")
        .then(res => {
            res && PostReleaseUser(userId)
            .then(res => {
                if(res) {
                    openSuccessDialog();
                    mutate();
                } else {
                    openErrorDialog();
                }
            })
        })
    }

    interface SearchParamType {
        loginId: string,
        userName: string,
        authority: string,
    }

    const [searchParam, setSearchParam] = useState<SearchParamType>({
        loginId: "",
        userName: "",
        authority: "",
    });

    const loginIdRef = useRef<HTMLInputElement>();
    const userNameRef = useRef<HTMLInputElement>();
    const authorityRef = useRef<HTMLInputElement>();

    function SearchUser() {
        setSearchParam({
            loginId: loginIdRef.current !== undefined ? loginIdRef.current.value : "",
            userName: userNameRef.current !== undefined ? userNameRef.current.value : "",
            authority: authorityRef.current !== undefined ? authorityRef.current.value : "",
        })
    }

    function ResetSearch() {
        setSearchParam({
            loginId: "",
            userName: "",
            authority: "",
        })
    }

    function FilteredUserMaster() {

        return(
            userMaster?.filter(function(item:UserMasterType){
                if(searchParam.loginId === "" && searchParam.userName === "" && searchParam.authority === "") {
                    return true;
                }
    
                return (
                    searchParam.loginId !== "" ? item.login_id.includes(searchParam.loginId) : true &&
                    searchParam.userName !== "" ? item.user_name.includes(searchParam.userName) : true &&
                    searchParam.authority !== "" ? item.authority_id === Number(searchParam.authority) : true
                );
            })
        );
    }

    function UserList() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper sx={{overflow:"hidden", whiteSpace:"nowrap"}}>
                        <Box m={2} p={1}>
                            <TableContainer sx={{maxHeight:800}}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>ログインID</TableCell>
                                            <TableCell>ユーザー名</TableCell>
                                            <TableCell>権限</TableCell>
                                            <TableCell>コンペ状況</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* {userMaster?.map((item:UserMasterType, index:number) => { */}
                                        {FilteredUserMaster()?.map((item:UserMasterType, index:number) => {

                                            let authority:AuthorityMasterType | undefined = authorityMaster?.find((e:AuthorityMasterType) => e.authority_id === item.authority_id)
                                            let confirmText = item.confirm_status ? "コンペ選択済み" : "コンペ未選択"
                                            let selectable = authority?.authority_id === 2 || authority?.authority_id === 3;

                                            return(
                                                <TableRow key={index} hover>
                                                    <TableCell>{item.login_id}</TableCell>
                                                    <TableCell>{item.user_name}</TableCell>
                                                    <TableCell>{authority?.authority_name}</TableCell>
                                                    <TableCell>{selectable ? confirmText : "対象外"}</TableCell>
                                                    <TableCell>
                                                        <Button variant="contained" size="small" onClick={() => OpenEditor(item)}>編集</Button>
                                                        &nbsp;
                                                        <Button variant="contained" size="small" color="error"
                                                            onClick={() => ReleaseUser(item?.user_id)}
                                                            sx={{
                                                                display:selectable && item.confirm_status ? "" : "none"
                                                            }}
                                                        >
                                                            選択状態解除
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })} 
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box m={2} textAlign="left">
                                <Button variant="contained" onClick={() => OpenEditor(undefined)}>新規作成</Button>
                            </Box>
                        </Box>
                    </Paper>
                </Grid2>
            </>
        );
    }

    function SearchWindow() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Box m={2} p={1}>
                            <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                                <Grid2 xs={12} sm="auto">
                                    <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                                        {"ログインID"}
                                    </Typography>  
                                </Grid2>
                                <Grid2 xs={12} sm={2}>
                                    <TextField 
                                        fullWidth
                                        size="small"
                                        inputRef={loginIdRef}
                                        defaultValue={searchParam.loginId}
                                    />
                                </Grid2>
                            </Grid2>

                            <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                                <Grid2 xs={12} sm="auto">
                                    <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                                        {"ユーザー名"}
                                    </Typography>  
                                </Grid2>
                                <Grid2 xs={12} sm={2}>
                                    <TextField 
                                        fullWidth
                                        size="small"
                                        inputRef={userNameRef}
                                        defaultValue={searchParam.userName}
                                    />
                                </Grid2>
                            </Grid2>

                            <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                                <Grid2 xs={12} sm="auto">
                                    <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                                        {"権限　　　"}
                                    </Typography>  
                                </Grid2>
                                <Grid2 xs={12} sm={2}>
                                    <Select sx={{textAlign:"left"}} fullWidth size="small"
                                        inputRef={authorityRef}
                                        defaultValue={searchParam.authority}
                                    >
                                        <MenuItem key={0} value="">{"　"}</MenuItem>
                                        {authorityMaster?.map((item:AuthorityMasterType,index:number) => (
                                            <MenuItem key={index} value={item.authority_id}>{item.authority_name}</MenuItem>
                                        ))}
                                    </Select>
                                </Grid2>
                            </Grid2>

                            <Box m={1}>
                                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                                    <Grid2>
                                        <Button variant="contained" size="small" onClick={SearchUser}>
                                            検索
                                        </Button>
                                    </Grid2>      
                                    <Grid2>
                                        <Button variant="outlined" size="small" onClick={ResetSearch}>
                                            リセット
                                        </Button>
                                    </Grid2>            
                                </Grid2>
                            </Box> 
                        </Box>
                    </Paper>
                </Grid2>
            </>
        );
    }

    function UserListWindows() {
        return(
            <>
                <SearchWindow/>
                <UserList/>

                <SuccessDialog/>
                <ErrorDialog/>
                <ConfirmDialog/>
            </>
        );
    }

    function EditWindow() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Box m={2} p={1}>
                            <UserMasterEdit 
                                editData={editData} 
                                CompleteEdit={CompleteEdit}    
                                setEditing={setEditing}
                            />
                        </Box>
                    </Paper>
                </Grid2>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                ユーザーマスタ
            </Typography>

            {editing ? <EditWindow/> : <UserListWindows/>}
        </>
    );
}